export default "__VITE_ASSET__CAZOEXXn__"